import {EventEmitter, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LocalizationHandlerService {
  onLanguageChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private _Translate: TranslateService) {
  }

  changeLanguage(lang){
    (lang);
    // this.translate.setDefaultLang('en');
    this._Translate.use(lang);
  }

  currentLang(){
    return this._Translate.currentLang;
  }

  init(){
    this._Translate.setDefaultLang('en');
    this._Translate.use('en');
    // this.translate.get('dashboard.default.doorsStatus.titleMain').subscribe(res => window.alert(res), res => window.alert(res));
  }

  getTranslation(key){
    return this._Translate.get(key);
  }

}
